import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

export default function PausedStoresInfoModal({
  isOpen,
  setWelcomeOpen,
  storesNotServiceable,
}) {


  return (
 <Modal
  isOpen={isOpen}
 
  isCentered
  closeOnOverlayClick={false}
  closeOnEsc={false}
  size="xl"
>
  <ModalOverlay />
  <ModalContent roundedTopRight="0" roundedBottomLeft="0">
    <ModalBody p="0" m="0" className="blockBg">
      <Flex direction="column" roundedTopLeft="10" roundedBottomRight="10">
        {/* Top red bar */}
        <Flex justifyContent="flex-end">
          <Box w="35%" h="5px" bg="brand.red" roundedBottomLeft="md" />
        </Flex>

        <VStack textAlign="center" spacing="4" p="10" mt="10">
          <Image
            src={require('../../../assets/logo/Full-Logo.svg')}
            w="170px"
          />

          <Text color="brand.red" fontSize="lg" mt="10">
            Welcome to 1800Spirits
          </Text>

          {storesNotServiceable?.length > 0 && (
            <>
              <Text fontWeight="bold" fontSize="lg" mt="6" color="white">
                Orders are paused for below stores:
              </Text>

              {/* Store List - Pills/Tags with wrapping */}
              <Flex 
                wrap="wrap" 
                gap="3" 
                mt="4" 
                justifyContent="center"
                maxW="600px"
              >
                {storesNotServiceable.map((notServiceableStore, idx) => (
                  <Box
                    key={idx}
                    bg="white"
                    color="gray.700"
                    px="4"
                    py="2"
                    rounded="lg"
                    fontSize="sm"
                    fontWeight="normal"
                  >
                    {notServiceableStore.storeName}
                  </Box>
                ))}
              </Flex>
            </>
          )}

              <Flex pb="8" direction="row" pt="5">
                <Box>
                  <Button
                    type="submit"
                    _hover={{ background: 'brand.red' }}
                    onClick={() => {
                     setWelcomeOpen(false);
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </Flex>
            </VStack>
            <Box
              w="35%"
              h="5px"
              bg="brand.red"
              roundedTopRight="md"
              alignItems="flex-end"
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
